import React from 'react';

const ServicesSection = () => {
  const services = [
    {
      image: '/images/all/multi-wallet-connection.png',
      title: 'DApp Integration',
      description: 'Connect decentralized applications to mobile wallets seamlessly across all major blockchain networks with our advanced integration protocols.'
    },
    {
      image: '/images/all/dapp-Integration-grid.png',
      title: 'Advanced Web3 Firewall',
      description: 'Our advanced Web3 firewall alerts, informs, and protects users from high-risk approvals and known scams. Sensitive on-chain transactions are classified into clear risk levels based on transaction sensitivity, permission scope, and threat intelligence.'
    },
    {
      image: '/images/all/ai-protection-visual.png',
      title: 'AI-Powered Security',
      description: 'Advanced artificial intelligence continuously monitors and protects your digital assets from emerging threats and vulnerabilities.'
    },
    {
      image: '/images/all/encryption-process-diagram.png',
      title: 'Military-Grade Encryption',
      description: 'Bank-level encryption protocols ensure your private keys and sensitive data remain secure with zero-knowledge architecture.'
    },
    {
      image: '/images/all/recovery-phrase-security.png',
      title: 'Automated Backup',
      description: 'Never lose access to your funds with our intelligent backup system that creates secure, encrypted copies across multiple locations.'
    },
    {
      image: '/images/all/biometric-authentication.png',
      title: 'Biometric Security',
      description: 'Advanced biometric authentication including fingerprint, face recognition, and voice authentication for ultimate security.'
    },
    {
      image: '/images/all/cross-chain-bridge.png',
      title: 'Cross-Chain Bridge',
      description: 'Seamlessly transfer assets across different blockchain networks with our secure, fast, and cost-effective bridge technology.'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-deepspace-100/30 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16" data-aos="fade-up">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-4">
            Our Services
          </h2>
          
          <p className="text-base sm:text-lg text-text-secondary max-w-3xl mx-auto">
            Comprehensive Web3 security solutions designed to protect your digital assets with cutting-edge technology and industry-leading protocols.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-dark-card/80 backdrop-blur-sm border border-dark-border/50 rounded-2xl overflow-hidden transition-all duration-500 hover:border-cyber-blue/50 hover:bg-dark-card shadow-[0_8px_30px_rgb(0,0,0,0.5)] hover:shadow-[0_20px_50px_rgba(0,212,255,0.3)] hover:scale-105"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              {/* Card Image */}
              <div className="relative h-52 overflow-hidden bg-gradient-to-br from-cyber-blue/10 to-cyber-gold/10">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-dark-card to-transparent opacity-70"></div>
              </div>

              {/* Card Content */}
              <div className="p-8">
                <h3 className="text-xl lg:text-2xl font-bold text-text-primary mb-4 group-hover:text-cyber-blue transition-colors duration-300">
                  {service.title}
                </h3>
                
                <p className="text-text-secondary leading-relaxed text-base">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;